import { Stack, TextField, Typography } from '@mui/material';

import Form from 'components/Form';

import { IFormRegister } from '../type';

interface Props extends IFormRegister {
  disabled?: boolean;
}

function Remarks({ register, disabled }: Props) {
  return (
    <Stack spacing={2}>
      <Form.Item label="Đánh giá điều dưỡng">
        <TextField
          // required
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('assessment')}
        />
      </Form.Item>
      <Form.Item label="Chẩn đoán điều dưỡng">
        <div style={{ height: 'auto', display: 'flex' }}>
          <TextField
            sx={{ height: '60px', width: '360px' }}
            // required
            multiline
            minRows={1}
            maxRows={2}
            size="small"
            variant="outlined"
            disabled={disabled}
            {...register('diagnosisRelate')}
          />
          <div style={{ height: '30px', marginTop: '5px', marginLeft: 45 }}>
            <Typography
              sx={{ fontSize: '13px', lineHeight: '14px', width: '60px' }}
            >
              Liên quan <br />
              tới
            </Typography>
          </div>
        </div>
        <TextField
          // required
          fullWidth
          multiline
          minRows={1}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('diagnosis')}
        />
      </Form.Item>
      <Form.Item label="Mục tiêu điều dưỡng">
        <TextField
          // required
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('goal')}
        />
      </Form.Item>
      <Form.Item label="Kế hoạch điều dưỡng">
        <TextField
          // required
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('plan')}
        />
      </Form.Item>
      <Form.Item label="Thực hành can thiệp điều dưỡng">
        <TextField
          // required
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('interventions')}
        />
      </Form.Item>
      <Form.Item label="Đánh giá điều dưỡng">
        <TextField
          // required
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('evaluation')}
        />
      </Form.Item>
    </Stack>
  );
}

export default Remarks;
